import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

let lenis: Lenis | null = null;

export default function SmoothScroll() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        lenis = new Lenis({ autoRaf: true, lerp: 0.09, wheelMultiplier: 0.95 });
        return () => {
            lenis?.destroy();
            lenis = null;
        };
    }, []);

    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                setTimeout(() => lenis?.scrollTo(el as HTMLElement, { offset: -110 }), 80);
                return;
            }
        }
        lenis?.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
}
